'use strict';

import './index.less';
import React from 'react';
import classnames from 'classnames';

import { Tab, TabTheme } from './Tab';

const findContentIndex = (requestedId: string, tabs: Tab[]) => {
	const id = tabs.findIndex(tab => tab.id === requestedId);
	return id !== -1 ? id : 0;
};

type ClickHandler = (id: string) => void;

interface Props {
	tabs: Tab[];
	contents?: React.ReactElement<any>[];
	colour?: string;
	activeColour?: string;
	initialId: string;
	theme?: TabTheme;
	handleClick: ClickHandler;
}

interface State {
	selectedIndex: number;
}

export class TabbedSelector extends React.Component<Props, State> {
	constructor(props: Props) {
		super(props);

		const selectedIndex =
			props.initialId && props.tabs ? findContentIndex(props.initialId, props.tabs) : 0;
		this.state = { selectedIndex };
	}

	render() {
		const { tabs, contents, colour, handleClick, theme = TabTheme.SWITCH } = this.props;

		const { selectedIndex } = this.state;
		return (
			<div className="TabbedSelector">
				<div className={classnames(`TabbedSelector__tabs`, `TabbedSelector__tabs--theme-${theme}`)}>
					{tabs &&
						tabs.length > 1 &&
						tabs.map((tab, index) => {
							return (
								<Tab
									colour={colour}
									{...tab}
									background={(theme === TabTheme.SWITCH && tab.background) || null}
									key={tab.id}
									theme={theme}
									handleClick={() => {
										tab.handleClick && tab.handleClick(tab.id);
										handleClick && handleClick(tab.id);
										this.setState({ selectedIndex: index });
									}}
									selected={selectedIndex === index}
								/>
							);
						})}
				</div>
				{contents && contents[selectedIndex]}
			</div>
		);
	}
}
